<template>
	<div>
		<meta name="referrer" content="no-referrer" />
		<el-container>
			<el-header :style="'background-color:' + nowTheme">
				<div class="flex">
					<div class="logo flex" @click="homeIndex" style="cursor: pointer;">
						<img src="../../assets/logo.png" alt="" height="60px" />
						<h4 style="display: inline-block;">{{ appName ? appName + '后台管理系统' : '后台管理系统' }}</h4>
					</div>
					<div class="flex">
						<div>欢迎回来，</div>
						<div>
							<el-menu
								:background-color="nowTheme"
								text-color="#fff"
								active-text-color="#ffd04b"
								unique-opened
								menu-trigger="click"
								mode="horizontal"
								class="title-menu"
							>
								<el-submenu index="1">
									<template slot="title">
										{{ JSON.parse($store.state.user.userInfo).name_text }}
									</template>
									<el-menu-item @click="changePassword" index="1-1">修改密码</el-menu-item>
									<el-menu-item @click="logout" index="1-2">退出登录</el-menu-item>
								</el-submenu>
								<el-menu-item class="hidden-sm-and-down" @click="FrontWebSite" index="2">网站预览</el-menu-item>
								<el-menu-item class="hidden-sm-and-down" @click="changeTheme" index="3">切换主题</el-menu-item>
								<el-menu-item class="hidden-sm-and-down" @click="clearRuntime" index="4">清除缓存</el-menu-item>
							</el-menu>
						</div>
						<el-dropdown trigger="click" @command="lngCommand">
							<el-button type="primary" icon="el-icon-edit" size="mini">
								语言切换
								<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown" v-if="lngMenu.length">
								<div v-for="(item, index) in lngMenu" :key="index">
									<el-dropdown-item :command="item.lng" :class="item.lng == defaultLng ? 'color-blue' : ''">{{ item.lngtitle }}</el-dropdown-item>
								</div>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
				<div>
					<el-menu
						mode="horizontal"
						:default-active="routepath"
						class="el-menu-demo flex-start"
						@open="handleOpen"
						@close="handleClose"
						:default-openeds="defaultOpenedsArray"
						:background-color="nowTheme"
						text-color="#fff"
						active-text-color="#ffd04b"
						unique-opened
						router
						menu-trigger="click"
					>
						<el-submenu v-for="(item, index) in navList" :key="index" :index="String(index)">
							<template slot="title">
								<i v-if="item.icon" :class="item.icon"></i>
								{{ item.name }}
							</template>
							<span v-for="(cell, key) in item.children" :key="key" :index="cell.path">
								<template v-if="cell.children">
									<el-submenu :index="'cell' + String(key)">
										<template slot="title">
											<i v-if="cell.icon" :class="cell.icon"></i>
											{{ cell.name }}
										</template>
										<el-menu-item v-for="(grid, sign) in cell.children" :key="'grid' + String(sign)" :index="grid.path">
											<i v-if="grid.icon" :class="grid.icon"></i>
											{{ grid.name }}
										</el-menu-item>
									</el-submenu>
								</template>
								<el-menu-item v-else :key="key" :index="cell.path">
									<i v-if="cell.icon" :class="cell.icon"></i>
									{{ cell.name }}
								</el-menu-item>
							</span>
						</el-submenu>
					</el-menu>
				</div>
			</el-header>
			<el-breadcrumb separator="/" class="breadcrumb" v-if="paths_loaded">
				<el-breadcrumb-item>当前位置> {{ currentPath['parent_name'] }}</el-breadcrumb-item>
				<el-breadcrumb-item>
					<el-button type="text" @click="toPath(currentPath['current_path'])">{{ currentPath['current_name'] }}</el-button>
				</el-breadcrumb-item>
				<el-breadcrumb-item>{{ currentPath['current_label'] }}</el-breadcrumb-item>
			</el-breadcrumb>
			<!-- 主体 -->
			<div @click="closeMenu">
				
				<el-container style="width: calc(100% - 40px);">
					<el-main>
						<keep-alive include="doclist,home,fileManage,userPublish,pubinfolist,companyType,typelist"><router-view ></router-view></keep-alive>
					</el-main>
				</el-container>
			</div>
			
			<el-footer class="hidden-sm-and-up">
				<el-menu
					:default-active="routepath"
					class="el-menu-vertical-demo flex"
					@open="handleOpen"
					@close="handleClose"
					:background-color="nowTheme"
					text-color="#fff"
					active-text-color="#ffd04b"
					unique-opened
					router
					menu-trigger="click"
					mode="horizontal"
				>
					<template v-for="(item, index) in navList">
						<el-submenu v-if="item.children" :key="index" :index="String(index)" style="width: 33.33%;">
							<template slot="title">
								{{ item.name }}
							</template>
							<el-menu-item v-for="(cell, key) in item.children" :key="key" :index="cell.path">{{ cell.name }}</el-menu-item>
						</el-submenu>
						<el-menu-item v-else :key="index" :index="item.path" style="width: 33.33%;">{{ item.name }}</el-menu-item>
					</template>
				</el-menu>
			</el-footer>
		</el-container>

		<el-dialog title="修改密码" :visible.sync="dialogVisible" :before-close="dialogClose" :close-on-click-modal="false">
			<el-form :model="pswdForm" status-icon :rules="rules" ref="pswdForm" label-width="80px" class="demo-pswdForm" style="max-width: 500px;margin:30px auto;">
				<el-form-item label="原始密码" prop="oldpswd"><el-input type="text" v-model="pswdForm.oldpswd" autocomplete="off"></el-input></el-form-item>
				<el-form-item label="新密码" prop="newpswd"><el-input type="password" v-model="pswdForm.newpswd" autocomplete="off"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取 消</el-button>
				<el-button type="primary" @click="submitForm('pswdForm')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="切换主题" :visible.sync="themeDialogVisible" width="30%" :before-close="themeDialogClose" :close-on-click-modal="false">
			<span><el-color-picker v-model="themeColor" @change="changeThemeColor"></el-color-picker></span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeThemeDialog">取 消</el-button>
				<el-button type="primary" @click="changeThemeConfirm">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 滚动到顶部组件 -->
		<el-backtop></el-backtop>
	</div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	data() {
		var checkUser = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入原始密码'));
			} else {
				callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入新密码'));
			} else {
				if (this.pswdForm.checkPass !== '') {
					this.$refs.pswdForm.validateField('checkPass');
				}
				callback();
			}
		};
		return {
			dialogVisible: false,
			themeDialogVisible: false,
			themeColor: '#141C23',
			pswdForm: {
				adminid: JSON.parse(this.$store.state.user.userInfo).id,
				token: JSON.parse(this.$store.state.user.userInfo).token,
				oldpswd: '',
				newpswd: ''
			},
			rules: {
				newpswd: [
					{
						validator: validatePass,
						trigger: 'blur'
					}
				],
				oldpswd: [
					{
						validator: checkUser,
						trigger: 'blur'
					}
				]
			},
			navList: [], //操作菜单
			paths: [],
			paths_loaded: false,
			defaultLng: 'cn',
			lngMenu: [],
		};
	},
	computed: {
		...mapState({
			defaultOpenedsArray: state => state.auth.defaultOpenedsArray
		}),
		routepath() {
			console.log('path', this.$route.path);
			var name = this.$route.name;
			if (name) {
				for (let i in this.navList) {
					if (name == this.navList[i].path) {
						name = this.navList[i].path;
						return;
					}
				}
			} else {
				name = this.$route.path;
			}
			return name;
		},
		nowTheme() {
			return this.$store.state.theme.defaultTheme;
		},
		appName() {
			return this.$store.state.auth.appName;
		},
		currentPath() {
			let path = this.$route.path;
			console.log('routepath', this.paths, this.$route);
			if (path === '/home') {
				return { parent_name: '系统', current_name: '首页' };
			} else {
				if (!this.paths[path]) {
					path = this.$route.matched[0].path;
				}
				let parent_name = this.paths[path].belong.name;
				return {
					parent_name: this.paths[path].belong.name,
					current_name: this.paths[path].name,
					current_path: this.paths[path].path,
					current_label: this.$route.meta.label
				};
			}
		}
	},
	methods: {
		...mapActions({
			exit: 'auth/logout',
			changePswd: 'auth/changePassword',
			setTheme: 'theme/setTheme'
		}),
		...mapMutations({
			setAppName: 'auth/setAppName',
			setHost: 'auth/setHost',
			setDefaultOpenedsArray: 'auth/setDefaultOpenedsArray'
		}),
		closeMenu() {
			event.stopPropagation();
			if (this.defaultOpenedsArray.length) {
				this.setDefaultOpenedsArray([]);
			}
		},
		handleOpen(key, keyPath) {
			this.setDefaultOpenedsArray(keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		dialogClose(done) {
			done();
		},
		themeDialogClose(done) {
			done();
		},
		logout() {
			this.exit().then(res => {
				console.log(res);
				if (res.actionStatus == 1) {
					this.$router.push('/login');
				}
			});
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.openFullScreen1();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		changePassword() {
			this.dialogVisible = true;
		},
		closeDialog() {
			this.dialogVisible = false;
			this.resetForm('pswdForm');
		},
		closeThemeDialog() {
			this.themeDialogVisible = false;
		},
		changeTheme() {
			this.themeDialogVisible = true;
		},
		changeThemeColor(e) {
			console.log(e);
		},
		changeThemeConfirm() {
			this.setTheme(this.themeColor).then(res => {
				this.themeDialogVisible = false;
			});
		},
		openFullScreen1() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.4)'
			});
			setTimeout(() => {
				let url = this.HOST + '/admin.index/changePassword';
				this.changePswd({
					url,
					data: this.pswdForm
				}).then(res => {
					console.log(res);
					loading.close();
					this.dialogVisible = false;
					if (res.status == 1) {
						this.$router.replace('/login');
					}
				});
			}, 2000);
		},
		clearRuntime() {
			console.log('执行请求清除缓存');
			this.$axios({
				url: this.HOST + '/admin.index/clear',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		homeIndex() {
			this.$router.push('/home');
		},
		FrontWebSite() {
			window.open(this.HOST + '/', '_blank');
		},
		lngCommand(command) {
			console.log(command);
			this.$axios({
				url: this.HOST + '/admin.index/changeLng',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					lng: command
				}
			})
				.then(res => {
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						window.location.reload();
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		getTabMenus() {
			this.$axios({
				url: this.HOST + '/admin.index/getMemus',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.setAppName(res.data.systemName);
						this.navList = res.data.navbar;
						this.paths = res.data.paths;
						this.paths_loaded = true;
						this.lngMenu = res.data.lngMenu;
						this.defaultLng = res.data.defaultLng;
					}
				})
				.catch(err => {});
		},
		toPath(path) {
			console.log(path);
			this.$router.push(path);
		},
	},
	mounted() {
		this.setHost(this.HOST);
		this.$axios({
			url: this.HOST + '/admin.index/getMemus',
			method: 'post',
			data: {
				adminid: JSON.parse(this.$store.state.user.userInfo).id,
				token: JSON.parse(this.$store.state.user.userInfo).token
			}
		})
			.then(res => {
				if (res.data.status == 0) {
					if (res.data.admin_err == 'admininfo_error') {
						this.$message.error(res.data.msg);
						this.exit().then(res => {
							console.log(res);
							if (res.actionStatus == 1) {
								this.$router.push('/login');
							}
						});
					}
				} else {
					this.setAppName(res.data.systemName);
					this.navList = res.data.navbar;
					this.paths = res.data.paths;
					this.paths_loaded = true;
					this.lngMenu = res.data.lngMenu;
					this.defaultLng = res.data.defaultLng;
				}
			})
			.catch(err => {});
	},
};
</script>

<style>
.el-header {
	height: auto !important;
}
.flex {
	display: flex;
	justify-content: space-between;
}
.flex-start {
	display: flex;
	justify-content: flex-start;
}
.el-menu {
	border-right: 0 !important;
}
.el-menu-item.is-active {
	border: none !important;
}
@media screen and (max-width: 768px) {
	.el-dialog {
		width: 80% !important;
	}
}
.title-menu::before,
.title-menu::after {
	display: inline;
}
.breadcrumb {
	line-height: 40px;
	font-size: 15px;
	padding: 0 20px;
}
</style>
